import { Checkbox, Text } from '@moda/om';
import React, { FC } from 'react';
import { CartPrice } from '../../../../hooks/useCart';
import { formatPrice } from '../../../../lib/formatPrice';

import './OrderDetailsSiteEarningsSection.scss';

interface Props {
  balance: CartPrice;
  toBeUsed: CartPrice;
  title: string;
  checked: boolean;
  onChange: () => void;
}

export const OrderDetailsSiteEarningsSection: FC<Props> = ({
  balance,
  title,
  toBeUsed,
  checked,
  onChange
}) => (
  <div className="OrderDetailsSiteEarningsSection">
    <Checkbox
      className="OrderDetailsSiteEarningsSection__checkbox"
      checked={checked}
      onClick={onChange}
    >
      <Text treatment="body1">{title}</Text>
    </Checkbox>

    <Text treatment="body1">{formatPrice(balance.currency, balance.price)} available</Text>

    <Text treatment="body1">{formatPrice(toBeUsed.currency, toBeUsed.price)} will be applied</Text>
  </div>
);
